module.exports = __webpack_public_path__ + "static/img/brand-first-5.318c1eea.png";